const castNames = [
  'れい', 'おとは', 'さや', 'つき', 'ゆら', 'せいな', 'ひなの', 'もえか', 'あやの', 'ゆき',
  'まお', 'さな', 'ゆゆ', 'よんす', 'しおん', 'みづき', 'もも', '美冬', 'かのん', 'ひめ',
  'みな', 'はな', 'いお', 'まりな', 'れいな', 'まりあ', 'みに', 'のあ', 'める', 'きほ',
  'りおな', 'ねじれ', 'はる', 'りん', 'みく', 'さくら', 'あい', 'せりな', 'うる', 'みほの',
  'ななこ', 'はづき', 'なみ', 'いちか', 'のどか', 'さゆり', 'みか', 'なな', 'みさ', 'なぎさ',
  'ふうか', 'みり', 'れみ', 'ねね', 'つむぎ', 'みやび', 'ひな', 'かえで', 'あかり', 'ひとみ',
  'ちひろ', 'あいか', 'すずな', 'その', 'きらり', 'あいな', 'あいり', 'あお', 'あおば', 'あき',
  'あけみ', 'あすか', 'あすみ', 'あに', 'あひ', 'あやね', 'あやめ', 'あゆな', 'タンゴ', 'まりん',
  'あおん', 'ゆな', 'りの', 'あんな', 'いろ', 'ののか', 'あむ', 'うゆ', 'さやか', 'うわ',
  'えい', 'えつこ', 'えつみ', 'えぬ', 'えりか', 'おて', 'かう', 'かおるこ', 'かすみ', 'せな',
  'かなえ', 'かほ', 'かよ', 'かりん', 'かんな', 'きき', 'きさ', 'きせ', 'きよ', 'くあ',
  'くう', 'くてち', 'くみ', 'くみみ', 'くるみん', 'くるる', 'けい', 'けいこ', 'けうる', 'けき',
  'けう', 'こあ', 'ここ', 'ここみ', 'こと', 'ことね', 'こふり', 'これ', 'さえ', 'さおり',
  'さき', 'さきな', 'さちこ', 'さとみ', 'さなえ', 'さなめ', 'しおり', 'しげこ', 'しずく', 'しほ',
  'しほり', 'しゆ', 'すう', 'すずか', 'すて', 'すみれ', 'すよ', 'せいら', 'せう', 'せお',
  'せりか', 'そろ', 'たちう', 'たねな', 'たまき', 'たれ', 'ちあ', 'ちう', 'ちえ', 'ちえり',
  'ちか', 'ちさと', 'ちなつ', 'ちぬ', 'つう', 'つばさ', 'てし', 'てそ', 'とい', 'ともか',
  'とろ', 'なお', 'なおみ', 'なおこ', 'なくる', 'なち', 'なつみ', 'ななみ', 'なり', 'なりす',
  'にこり', 'にま', 'ぬい', 'ねの', 'ねゆ', 'のぞみ', 'のと', 'のね', 'のの', 'のりこ',
  'はお', 'はなか', 'はるか', 'はるの', 'はるひ', 'はるみ', 'ひい', 'ひかり', 'ひかる', 'ひこた',
  'ひさこ', 'ひとえ', 'ひなこ', 'ひまり', 'ひむ', 'ひより', 'ひろみ', 'ふてこ', 'ふみか', 'ふら',
  'へう', 'へむ', 'ほたる', 'ほのか', 'ほのぬ', 'まいこ', 'まいまい', 'まき', 'まきこ', 'まこと',
  'まこみ', 'まさみ', 'まの', 'まひろ', 'まほ', 'まゆ', 'まゆみ', 'まよ', 'まり', 'みおな',
  'みき', 'みさき', 'みさと', 'みそな', 'みつき', 'みどり', 'みのり', 'みほ', 'みゆう', 'みよ',
  'みわ', 'むい', 'むへ', 'めた', 'めぬ', 'もち', 'もん', 'やも', 'ゆいな', 'ゆうか',
  'ゆうな', 'ゆか', 'ゆかこ', 'ゆかち', 'ゆかの', 'ゆきえ', 'ゆきこ', 'ゆきな', 'ゆきの', 'ゆず',
  'ゆずき', 'ゆは', 'ゆほ', 'ゆめか', 'ゆめの', 'ゆめみ', 'ゆりか', 'ゆりな', 'ようこ', 'よと',
  'らな', 'らら', 'りあ', 'りぃこ', 'りえ', 'りお', 'りさこ', 'りなち', 'りほ', 'りま',
  'りょうこ', 'りんか', 'りんりん', 'るう', 'るた', 'るな', 'れいみ', 'れそ', 'れな', 'れほ',
  'ろな', 'ろり', 'りこ', 'あおい', 'みゆ', 'みま', 'ゆあ', 'にの', '黒崎あずさ', 'かれん',
  'るあ', 'あゆ', 'あみ', 'しずか', 'みれい', 'あやか', 'みけ', 'みいひ', 'るり', 'ありす',
  'えり', 'あらん', 'りな', 'にぃな', 'ゆり', 'すず', 'うみ', 'りり', 'しいな', 'るる',
  'りのあ', 'ゆい', 'ろあ',
];

export default function CastList() {
  return (
    <div>
      <div className="text-center mb-10">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">在籍セラピスト一覧</h3>
        <p className="text-gray-400 text-sm mt-1">全{castNames.length}名在籍（全員20歳以上）</p>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-2">
        {castNames.map((name, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center bg-white hover:bg-pink-50 transition-colors duration-150 rounded-xl py-3 px-2 cursor-default border border-pink-100"
          >
            <span className="text-pink-300 text-xs mb-1 font-medium">
              {String(index + 1).padStart(3, '0')}
            </span>
            <span className="text-gray-700 text-sm font-semibold text-center leading-tight">
              {name}
            </span>
          </div>
        ))}
      </div>

      <p className="text-center text-gray-400 text-xs mt-8">
        ※ セラピストは予告なく変更になる場合がございます
      </p>
    </div>
  );
}
